import script from "./UserFileDocModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFileDocModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserFileDocModal.vue?vue&type=style&index=0&id=a5674228&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5674228"]])

export default __exports__